// function startGoogle() {
//     gapi.load('auth2', function() {
//         // Retrieve the singleton for the GoogleAuth library and set up the client.
//         auth2 = gapi.auth2.init({
//             client_id: '878596091494-tblmb5h2oa5qppq75h2vram75uo7asgl.apps.googleusercontent.com'
//         });

//     });
// }

import {LitElement, html, render, css} from 'lit';


(function() {

    DplLink.getParamByName = function(name, url) {
        if (!url) { url = window.location.href; }
        url = url.toLowerCase();
        name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) { return null; }
        if (!results[2]) { return ''; }
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };


    
    var openedManagePasswordView = null;
    DplLink.openManagePasswordView = function(params) {
        console.log('Opening Managed login view');
        if (openedManagePasswordView === null) {
            openedManagePasswordView = new DplLink.PopupLit();
            var userid = params.userid;
            var useridentityid = params.useridentityid;
            var create = params.create;
            var username = params.username;
            openedManagePasswordView.show(new DplLink.ManagePasswordView({ useridentityid, userid, create, username, closeCallback: function() { openedManagePasswordView.hide();
                    openedManagePasswordView = null; } }).el, { my: 'center', at: 'center', of: $(window), collision: 'fit' }, 'never');
        }
    };

    DplLink.openProvideEmailView = function() {
        var szAutoLogin = DplLink.getParamByName('autologin') ? DplLink.getParamByName('autologin') : 'f';
        if (DplLink.currentUser && DplLink.currentUser.authoptions && !DplLink.isImpersonating()) {
            if (DplLink.currentUser.authoptions.ISEMAILVALIDATED == 'f' &&
                DplLink.currentUser.authoptions.ISPENDINGEMAILVALIDATION == 'f' && szAutoLogin == 'f') {
                var lastEmailPopupTime;
                if (DplLink.isLocalStorageNameSupported) {
                    lastEmailPopupTime = localStorage.getItem('DplLink.lastemailpopuptime');
                }
                var curTS = Math.round(new Date().getTime() / 1000);
                if (!lastEmailPopupTime || curTS - parseInt(lastEmailPopupTime) >= (60 * 60 * 24 * 7)) {
                    var popup = new DplLink.Popup();
                    popup.show(new DplLink.ProvideEmailView({ ctnPopup: popup }).render().el, { my: 'center', at: 'center', of: $(window), collision: 'fit' }, 'never');
                    $('.provideEmailView .newEmail').focus();
                }
            }
        }
    };

    DplLink.openTermsOfServiceView = function() {
        //        var szAutoLogin = DplLink.getParamByName('autologin') ? DplLink.getParamByName('autologin') : 'f';
        //				if (DplLink.currentUser && DplLink.currentUser.authoptions && !DplLink.isImpersonating() && DplLink.currentUser.authoptions.ISAGREEDTOTOS == 'f' && szAutoLogin == 'f') {
        //            $('body').append('<div id="overlay"></div>');

        //            var popup = new DplLink.Popup();
        //            popup.show(new DplLink.TermsOfServiceView({ onCloseCallBack: DplLink.openProvideEmailView, ctnPopup: popup }).render().el, { my: 'center', at: 'center', of: $(window), collision: 'fit' }, 'never');
        //        }
        //        else {
        DplLink.openProvideEmailView();
        //        }
    };

    var OAUTHTYPE_GOOGLE = DplLink.OAUTHTYPE_GOOGLE = 1;
    var OAUTHTYPE_MICROSOFT = DplLink.OAUTHTYPE_MICROSOFT = 3;

    var checkOAuthLink = DplLink.checkOAuthLink = function(oauthType, done) {
        //DplLink.resetToGenuineSelf();
        var szType = '';
        if (oauthType == OAUTHTYPE_GOOGLE) {
            szType = 'google';
        //} else if (oauthType == OAUTHTYPE_FACEBOOK) {
            //szType = 'facebook';
        } else if (oauthType == OAUTHTYPE_MICROSOFT) {
            szType = 'microsoft';
        } else {
            return;
        }
        DplLink.apiCall({
            type: "get",
            url: DplLink.resthost + '/r/hasoauthtoken',
            data: { oauthtype: oauthType },
            success: function(data) {
                var bResult = false;
                var szImageURL = '';
                var szOAuthUserName = '';
                if (data[0]) {
                    bResult = data[0].result;
                    szImageURL = data[0].imageurl;
                    szOAuthUserName = data[0].oauthusername;
                }
                console.log('check for presence of oauth link result (' + szType + '): ' + bResult);
                //TODO -- do auth/api call to get username and image url
                if (DplLink.displayOauthLinkedStatus) {
                    DplLink.displayOauthLinkedStatus(oauthType, bResult, szImageURL, szOAuthUserName);
                }
                if (done) {
                    done(null, oauthType, bResult, szImageURL, szOAuthUserName);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("oauth token check error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                if (done) {
                    done(errorThrown);
                }
            }
        });

    };

    function checkOAuthLink_unautherized(oauthType, useridentityid, userid, done) {
        var szType = '';
        if (oauthType == OAUTHTYPE_GOOGLE) {
            szType = 'google';
        } else if (oauthType == OAUTHTYPE_MICROSOFT) {
            szType = 'microsoft';
        } else {
            return;
        }
        DplLink.apiCall({
            type: "get",
            url: DplLink.resthost + '/r/hasoauthtoken-unauthorized',
            data: { useridentityid, userid, oauthType },
            success: function(data) {
                var bResult = false;
                var szImageURL = '';
                var szOAuthUserName = '';
                if (data[0]) {
                    bResult = data[0].result;
                    szImageURL = data[0].imageurl;
                    szOAuthUserName = data[0].oauthusername;
                }
                console.log('check for presence of oauth link result (' + szType + '): ' + bResult);
                //TODO -- do auth/api call to get username and image url
                if (DplLink.displayOauthLinkedStatus) {
                    DplLink.displayOauthLinkedStatus(oauthType, bResult, szImageURL, szOAuthUserName);
                }
                if (done) {
                    done(null, oauthType, bResult, szImageURL, szOAuthUserName);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("oauth token check error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                if (done) {
                    done(errorThrown);
                }
            }
        });

    }

    /** Updates each `.oauthProviderBlock` row (Google/Microsoft) for ManageLoginView / ManageOauthView. */
    function syncOauthProviderUi(hostEl, provider, oauthstatus) {
        const block = hostEl.querySelector('.' + provider + 'Controls.oauthProviderBlock');
        if (!block) return;
        const userDiv = block.querySelector('.oauthUserProfile');
        if (!userDiv) return;

        const st = oauthstatus[provider];
        const linked = !!(st && st.isLinked);
        block.classList.toggle('is-linked', linked);

        if (!linked) {
            userDiv.innerHTML = '';
            return;
        }

        let szImage = '';
        if (provider === 'microsoft') {
            const name = st.oauthUserName || '';
            if (st.imageurl) {
                szImage = `<img class="socialFace" src="${st.imageurl}" alt="${name}"> ${name}`;
            } else {
                szImage = `<img class="socialFace" src="/css/images/portal/dpl_menu_user.png" alt="${name}"> ${name}`;
            }
        } else {
            const name = st.oauthUserName || '';
            if (st.imageurl) {
                szImage = `<img class="socialFace" src="${st.imageurl}" alt="${name}" referrerpolicy="no-referrer"> ${name}`;
            } else {
                szImage = name;
            }
        }
        userDiv.innerHTML = szImage;
    }

    /** Vertical oauthProviderList; each oauthProviderRow is flex space-between. Shared by ManageLoginView + ManageOauthView. */
    function oauthProviderBlocksLit(host) {
        return LH.html`
            <div class="oauthProviderList">
                <div class="oauthProviderRow oauthProviderBlock googleControls">
                    <div class="oauthCell oauthCellPrimary">
                        <span class="oauthAllowLabel oauthShowWhenUnlinked">Allow login with Google</span>
                        <button type="button" class="oauthUnlinkButton oauthShowWhenLinked" @click=${host.clickGoogleDeauthorizeButton.bind(host)}>Disallow login with Google</button>
                    </div>
                    <div class="oauthCell oauthCellSecondary">
                        <div class="oauthLinkButton oauthShowWhenUnlinked" title="Allow login with Google" @click=${host.clickGoogleAuthorizeButton.bind(host)}><div class="google-logo"></div>Google</div>
                        <div class="oauthUserProfile googleUserImageDiv oauthShowWhenLinked"></div>
                    </div>
                </div>
                <hr class="soft-1"/>
                <div class="oauthProviderRow oauthProviderBlock microsoftControls">
                    <div class="oauthCell oauthCellPrimary">
                        <span class="oauthAllowLabel oauthShowWhenUnlinked">Allow login with Microsoft</span>
                        <button type="button" class="oauthUnlinkButton oauthShowWhenLinked" @click=${host.clickMicrosoftDeauthorizeButton.bind(host)}>Disallow login with Microsoft</button>
                    </div>
                    <div class="oauthCell oauthCellSecondary">
                        <div class="oauthLinkButton oauthShowWhenUnlinked" title="Allow login with Microsoft" @click=${host.clickMicrosoftAuthorizeButton.bind(host)}><div class="microsoft-logo"></div>Microsoft</div>
                        <div class="oauthUserProfile microsoftUserImageDiv oauthShowWhenLinked"></div>
                    </div>
                </div>
            </div>
        `;
    }


    function linkGoogleAccount(bLinkAccount, isCreatePasswordPage, useridentityid, userid, emailToken, done) {
        // if (bLinkAccount) {
        //     auth2.grantOfflineAccess({ 'redirect_uri': 'postmessage', 'prompt': 'select_account' }).then(function(googleUser) {
        //         dplLinkOauthAccount(true, isCreatePasswordPage, OAUTHTYPE_GOOGLE, googleUser.code, userid, emailToken, done);
        //     }).catch(function(error) {console.error(error);});
        // } else {
        //     dplLinkOauthAccount(false, isCreatePasswordPage, OAUTHTYPE_GOOGLE, '', userid, emailToken, done);
        // }
		if (bLinkAccount) {
			google.accounts.id.initialize({
				client_id: '878596091494-tblmb5h2oa5qppq75h2vram75uo7asgl.apps.googleusercontent.com',
				callback: (res)=>{
					console.log(res);
					dplLinkGoogleAccount(true, isCreatePasswordPage, res.credential, useridentityid, userid, emailToken, done);
				}
			});
			google.accounts.id.prompt((notification) => {
				if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
				  // continue with another identity provider.
				}
			  });
		}else{
			dplLinkGoogleAccount(false, isCreatePasswordPage, '', useridentityid, userid, emailToken, done);
		}
    }

    function linkMicrosoftAccount(bLinkAccount, isCreatePasswordPage, useridentityid, userid, emailToken, done) {
		if (bLinkAccount) {
            const myMSALObj = new msal.PublicClientApplication(msalConfig);
            myMSALObj.loginPopup({ scopes:['email', 'profile', 'openid', 'User.Read'], prompt: 'select_account' })
                .then((response) => {
                    // console.log('msal response: ', response);
                    const accountId = response.account.homeAccountId;
                    dplLinkMicrosoftAccount(true, isCreatePasswordPage, response.accessToken, useridentityid, userid, emailToken, done);
                    DplLink.setMicrosoftAccountId(accountId);
                })
                .catch(error => {
                    console.error(error);
                });
		}else{
			dplLinkMicrosoftAccount(false, isCreatePasswordPage, '', useridentityid, userid, emailToken, done);
		}
    }


    // var loginWithGoogle = DplLink.loginWithGoogle = function(done) {
    //     auth2.grantOfflineAccess({ 'redirect_uri': 'postmessage', 'prompt': 'select_account' }).then(function(googleUser) {
    //         DplLink.oauthlogin({ authtoken: googleUser.code, oauthtype: OAUTHTYPE_GOOGLE }, done);
    //         return false;
    //     }).catch(function(error) {console.error(error);});
    //     return false;
    // };

    // var loginWithGoogleNew = DplLink.loginWithGoogleNew = function(googleUser,done) {
    //     auth2.grantOfflineAccess({ 'redirect_uri': 'postmessage', 'prompt': 'select_account' }).then(function(googleUser) {
    //         DplLink.oauthlogin({ authtoken: googleUser.code, oauthtype: OAUTHTYPE_GOOGLE }, done);
    //         return false;
    //     }).catch(function(error) {console.error(error);});
    //     return false;
    // };


	DplLink.googleLogin=function(res,verificationDetails,done) {
        $('#otp_error').hide();
        var autoselect_userid=$("input#userid").val();
		DplLink.apiCall({
            url: DplLink.resthost +'/r/googlelogin/',
			type: "GET",
			data: { credential:res.credential, ...verificationDetails, setUserTokenCookie: true, autoselect_userid },
            success: function(data) {
                if (!data) {
                    return;
                } else {
                    if (data.verifyMFA) {
                        showOTPForm(data.phoneNumberMasked, (verificationDetails) => { DplLink.googleLogin(res, verificationDetails, done) });
                    } else if (data.setupMFA) {
                        showMFASetupForm(data.currentPhone, (verificationDetails) => DplLink.googleLogin(res, verificationDetails, done));
                    } else {
                        var oauthtype = 1;
                        if (data) {
                            // Trigger a page reload of other tabs so they're in sync with this one, until we can support independent tab sessions again 
                            DplLink.refreshOtherTabs();

                            DplLink.clearLocalStorage();
                            DplLink.currentUser = {};
                            DplLink.currentCompany = {};

                            console.log('api login success (oauth)');

                            if (done) {
                                done(null, { ...data, oauthtype });
                            }
                        } else {
                            var szOauthType = "Google";
                            var szAccountSwitcherLink = "https://accounts.google.com";
                            //if (oauthtype == 2) {
                            //    szOauthType = "Facebook";
                            //    szAccountSwitcherLink = "https://www.facebook.com";
                            //}
                            if (done) {
                                //done ({ err_message : 'There is no eMMS user tied to the selected ' + szOauthType + ' account.' });
                                done({ err_message: 'Account is not linked or logged into. You can log in <a href="' + szAccountSwitcherLink + '" target="_blank">here</a> or link your account after logging in with a username and password.' });
                            }
                        }
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("rest login Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                if (jqXHR.responseText) {
                    $('#otp_error').text(jqXHR.responseText);
                    $('#otp_error').show();
                }
                if (done) {
                    done({ err_message: jqXHR.responseText });
                }
            },
            dataType: "json"
		});
	};


    // var oauthlogin = DplLink.oauthlogin = function(accountInfo, done) {
    //     $.ajax({
    //         url: DplLink.resthost + '/r/oauthlogin/',
    //         type: "GET",
    //         data: { accountinfo: JSON.stringify(accountInfo) },
    //         success: function(data) {
    //             if (!data) {
    //                 return;
    //             } else {
    //                 var token = data.apitoken;
    //                 var oauthtype = data.oauthtype;
    //                 if (token) {
    //                     var userid = data.userid;
    //                     var username = data.username;
    //                     var oauthid = data.oauthid;

    //                     DplLink.clearLocalStorage();
    //                     DplLink.deleteAuthTokens();
    //                     DplLink.currentUser = {};
    //                     DplLink.currentCompany = {};

    //                     console.log('api login success (oauth)');

    //                     if (done) {
    //                         done(null, userid, username, oauthid, oauthtype);
    //                     }
    //                 } else {
    //                     var szOauthType = "Google";
    //                     var szAccountSwitcherLink = "https://accounts.google.com";
    //                     //if (oauthtype == 2) {
    //                     //    szOauthType = "Facebook";
    //                     //    szAccountSwitcherLink = "https://www.facebook.com";
    //                     //}
    //                     if (done) {
    //                         //done ({ err_message : 'There is no eMMS user tied to the selected ' + szOauthType + ' account.' });
    //                         done({ err_message: 'Account is not linked or logged into. You can log in <a href="' + szAccountSwitcherLink + '" target="_blank">here</a> or link your account after logging in with a username and password.' });
    //                     }
    //                 }
    //             }
    //         },
    //         error: function(jqXHR, textStatus, errorThrown) {
    //             console.log("rest login Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
    //             if (done) {
    //                 done({ err_message: jqXHR.responseText });
    //             }
    //         },
    //         dataType: "json"

    //     });
    // };

    function updateEmmsTopRightStatus(err, oauthType, isLinked, profileImageURL, oauthUserName) {
        if (err) { return; }
        if (DplLink.displayOauthLinkedStatus) {
            if (isLinked) {
                DplLink.displayOauthLinkedStatus(oauthType, true, profileImageURL, oauthUserName);
            } else {
                DplLink.displayOauthLinkedStatus(oauthType, false, '', '');
            }
        }
    }


    // function dplLinkOauthAccount(bLink, iscreatePWPage, oauthType, oauthtoken, dplUserID, emailtoken, done) {
    //     var apiURL = '/r/linkoauthaccountauthorized/';
    //     if (iscreatePWPage) {
    //         apiURL = '/r/linkoauthaccount/';
    //     }
    //     DplLink.apiCall({
    //         url: DplLink.resthost + apiURL,
    //         type: "GET",
    //         data: { userid: dplUserID, oauthtype: oauthType, authtoken: oauthtoken, pwresettoken: emailtoken, link: bLink },
    //         success: function(data) {
    //             console.log('oauth account link or unlink return success');
    //             var profileImageURL = '';
    //             var oauthusername = '';
    //             var err = null;
    //             if (data) {
    //                 if (data.resultcode == 1) {
    //                     profileImageURL = data.imageurl;
    //                     oauthusername = data.oauthname;
    //                     updateEmmsTopRightStatus(null, oauthType, (data.resultcode == 1), profileImageURL, oauthusername);
    //                 } else if (data.resultcode == -2) {
    //                     //selected account already associated with a different user.
    //                     //alert('Cannot link the selected account as it is already associated with a different user.');
    //                     err = { code: -2, err_message: 'Cannot link the selected account as it is already associated with a different user.' };
    //                 }
    //             }


    //             if (done) {
    //                 done(err, oauthType, (data.resultcode == 1), profileImageURL, oauthusername);
    //             }
    //         },
    //         error: function(jqXHR, textStatus, errorThrown) {
    //             console.log("oauth account link Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
    //             updateEmmsTopRightStatus(errorThrown);
    //             //CallBackFn(errorThrown);
    //             if (done) {
    //                 done(errorThrown);
    //             }
    //         }
    //     });
    // }




	function dplLinkGoogleAccount(bLink, iscreatePWPage, credential, useridentityid, dplUserID, emailtoken, done) {
        var apiURL = '/r/linkgoogleaccountauthorized/';
        if (iscreatePWPage) {
            apiURL = '/r/linkgoogleaccount/';
        }
        DplLink.apiCall({
            url: DplLink.resthost + apiURL,
            type: "POST",
            data: { useridentityid: useridentityid, userid: dplUserID, credential: credential, pwresettoken: emailtoken, link: bLink },
            success: function(data) {
                console.log('oauth account link or unlink return success');
                var profileImageURL = '';
                var oauthusername = '';
                var err = null;
                if (data) {
                    if (data.resultcode == 1) {
                        profileImageURL = data.imageurl;
                        oauthusername = data.oauthname;
                        updateEmmsTopRightStatus(null, 1, (data.resultcode == 1), profileImageURL, oauthusername);
                        if (bLink) {
                            DplLink.NetworkMsgPopup.show('Login method linked successfully.', 'success', 5000);
                        }
                    } else if (data.resultcode == -2) {
                        //selected account already associated with a different user.
                        //alert('Cannot link the selected account as it is already associated with a different user.');
                        err = { code: -2, err_message: 'Cannot link the selected account as it is already associated with a different user.' };
                    }
                }


                if (done) {
                    done(err, 1, (data.resultcode == 1), profileImageURL, oauthusername);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("oauth account link Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                updateEmmsTopRightStatus(errorThrown);
                //CallBackFn(errorThrown);
                if (done) {
                    done(errorThrown);
                }
            }
        });
    }

    function dplLinkMicrosoftAccount(bLink, iscreatePWPage, accessToken, useridentityid, dplUserID, emailtoken, done) {
        var apiURL = '/r/linkmicrosoftaccountauthorized/';
        if (iscreatePWPage) {
            apiURL = '/r/linkmicrosoftaccount/';
        }
        DplLink.apiCall({
            url: DplLink.resthost + apiURL,
            type: "POST",
            data: { useridentityid, userid: dplUserID, accessToken: accessToken, pwresettoken: emailtoken, link: bLink },
            success: function(data) {
                console.log('oauth account link or unlink return success');
                var profileImageURL = '';
                var oauthusername = '';
                var err = null;
                if (data) {
                    if (data.resultcode == 1) {
                        profileImageURL = data.imageurl;
                        oauthusername = data.oauthname;
                        // updateEmmsTopRightStatus(null, 1, (data.resultcode == 1), profileImageURL, oauthusername);
                        if (bLink) {
                            DplLink.NetworkMsgPopup.show('Login method linked successfully.', 'success', 5000);
                        }
                    } else if (data.resultcode == -2) {
                        //selected account already associated with a different user.
                        //alert('Cannot link the selected account as it is already associated with a different user.');
                        err = { code: -2, err_message: 'Cannot link the selected account as it is already associated with a different user.' };
                    }
                }

                if (done) {
                    done(err, 3, (data.resultcode == 1), profileImageURL, oauthusername);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("oauth account link Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                updateEmmsTopRightStatus(errorThrown);
                if (done) {
                    done(errorThrown);
                }
            }
        });
    }

    DplLink.microsoftLogin = function(authenticationResult, verificationDetails, done) {
        const accountId = authenticationResult.account.homeAccountId;
        const accessToken = authenticationResult.accessToken;
        DplLink.setMicrosoftAccountId(accountId);
        $('#otp_error').hide();
        var autoselect_userid=$("input#userid").val();
        DplLink.apiCall({
            url: DplLink.resthost +'/r/microsoftlogin/',
			type: "POST",
			data: { accessToken, ...verificationDetails, setUserTokenCookie: true, autoselect_userid },
            success: function(data) {
                if (!data) {
                    return;
                } else {
                    if (data.verifyMFA) {
                        showOTPForm(data.phoneNumberMasked, (verificationDetails) => { DplLink.microsoftLogin(authenticationResult, verificationDetails, done) });
                    } else if (data.setupMFA) {
                        showMFASetupForm(data.currentPhone, (verificationDetails) => DplLink.microsoftLogin(authenticationResult, verificationDetails, done));
                    } else {
                        var token = data.apitoken;
                        if (token) {
                            // Trigger a page reload of other tabs so they're in sync with this one, until we can support independent tab sessions again 
                            DplLink.refreshOtherTabs();
                            DplLink.currentUser = {};
                            DplLink.currentCompany = {};

                            if (done) {
                                done(null, { ...data, oauthtype: 3 });
                            }
                        } else {
                            if (done) {
                                done({ err_message: 'Account is not linked or logged into. You can link your account after logging in with a username and password.' });
                            }
                        }
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log("rest login Error: " + textStatus + ", " + errorThrown + ", Status: " + jqXHR.status + ",Response: " + jqXHR.responseText);
                if (jqXHR.responseText) {
                    $('#otp_error').text(jqXHR.responseText);
                    $('#otp_error').show();
                }
                if (done) {
                    done({ err_message: jqXHR.responseText });
                }
            },
            dataType: "json"
		});
    }

    class ManageLoginView extends LitLite {
        static properties = {
            updatedPassword: { type: Boolean },
            useridentityid: { type: String },
            userid: { type: String },
            username: { type: String },
            pwresettoken: { type: String },
            closeCallback: { type: Function },
            validPassword: { type: Boolean },
            bOldPasswordChecked: { type: Boolean },
            bCanLinkSocialAccount: { type: Boolean },
            validNewPassword: { type: Boolean },
            conditionRequired: { type: Object },
            conditionStrength: { type: Object },
            validToken: { type: Boolean },
            errmsg: { type: String },
            oauthstatus: { type: Object },
        };
    
        constructor(options) {
            super();
            this.el.className = "manageLoginView";
            this.userid = this.userid ?? options.userid;
            this.useridentityid = this.useridentityid ?? options.useridentityid;
            this.username = this.username || options.username;
            this.pwresettoken = this.pwresettoken || options.pwresettoken;
            this.closeCallback = this.closeCallback || options.closeCallback;

            this.updatedPassword = false;
            this.validPassword = false;
            this.bOldPasswordChecked = true;
            this.bCanLinkSocialAccount = false;
            this.validNewPassword = false;
            this.conditionRequired = { pwLength: false, pwMatch: false };
            this.conditionStrength = { pwUpper: false, pwLower: false, pwDigit: false, pwSpChar: false };
            this.validToken = true;
            this.errmsg = "";
            this.oauthstatus = { google: {}, microsoft: {} };
    
            this.initialize();
        }
    
        initialize() {
            if (this.pwresettoken) {
                this.bOldPasswordChecked = false;
                this.bCanLinkSocialAccount = true;
            } else {
                if ((this.useridentityid === DplLink.currentUser.useridentityid || this.userid === DplLink.currentUser.userid) && !DplLink.getClonerUserId()) {
                    this.bCanLinkSocialAccount = true;
                }
                if (DplLink.getClonerUserId()) { // this should really be done serverside instead
                    this.bOldPasswordChecked = false;
                }
            }
            this.render();
            if (this.pwresettoken) {
                this.validateEmailToken();
                this.el.querySelector('.newPassword').focus();
            } else {
                this.updateView();
            }
            this.fetchOauthControls();
        }
    
        render() {
            const template = LH.html`
                <div class="closePanel">
                    <div class="ic-cancel closeManageLoginView" title="Close" @click=${this.closeManageLoginView}></div>
                </div>
                <div class="box-sub-hdr">
                    <div class="title txt">Change Password</div>
                </div>
                <div class="box-content" style="padding: 10px 40px">
                    <div class="ctnResetPasswordControls">
                        <div class="ctnOldPassword ctn">
                            <label>Old Password</label>
                            <input type="password" class="oldPassword" placeholder="old password" @keyup=${this.assesPasswordStrength}>
                        </div>
                        <div class="ctnNewPassword ctn">
                            <label>New Password</label>
                            <input type="password" class="newPassword" placeholder="new password" @keyup=${this.assesPasswordStrength} @focusout=${this.onFocusoutPwdTextbox}>
                            <div class="ctnPwdReqmts ctnReqmtsNewPwd" style="display: none;">
                                <div class="ctnInnerPwdReqmts">
                                    <div class="validPasswordMsg"></div>
                                    <div class="conditions">Required</div>
                                    <div class="pwLength"><div class="pwStrenghIndicator"></div>At least 8 characters in length</div>
                                    <div class="conditions">3 of the following 4 conditions must be met.</div>
                                    <div class="pwUpper"><div class="pwStrenghIndicator"></div>Contains at least one upper-case character</div>
                                    <div class="pwLower"><div class="pwStrenghIndicator"></div>Contains at least one lower-case character</div>
                                    <div class="pwDigit"><div class="pwStrenghIndicator"></div>Contains at least one numeric digit</div>
                                    <div class="pwSpChar"><div class="pwStrenghIndicator"></div>Contains at least one special character</div>
                                </div>
                            </div>
                        </div>
                        <div class="ctnConfirmPassword ctn">
                            <label>Confirm Password</label>
                            <input type="password" class="confirmPassword" placeholder="confirm password" @keyup=${this.assesPasswordStrength} @focusout=${this.onFocusoutPwdTextbox}>
                            <div class="ctnPwdReqmts ctnReqmtsConfirmPwd" style="display: none;">
                                <div class="ctnInnerPwdReqmts">
                                    <div class="pwMatch"><div class="pwStrenghIndicator"></div>Confirm password matches new password</div>
                                </div>
                            </div>
                        </div>
                        <div class="ctnButton ctn">
                            <div class="btnChangePassword" @click=${this.onChangePasswordClick}>Change</div>
                        </div>
                        <br/>
                    </div>
                    <div class="updateResult"></div>
                    <div class="oAuthControls">
                        <p>or choose an alternate login:</p>
                        <div class="errMsg"></div>
                        ${oauthProviderBlocksLit(this)}
                    </div>
                    <div class="loginUrl ctnButton"><a class="btnStandard" @click=${this.closeManageLoginView}>Continue to login page...</a></div>
                </div>
            `;
    
            LH.render(template, this.el, { host: this });
            this.updateView();
        }
        destroyer() {
            this.el.remove();
        }

        updateView() {
            this.updateErrMsg();
            if (this.pwresettoken) {
                this.el.querySelector('.ctnOldPassword') ? this.el.querySelector('.ctnOldPassword').style.display = 'none' : null;
                this.el.querySelector('.title').textContent = `Change password for ${this.username}`;
    
                if (!this.validToken) {
                    this.el.querySelector('.ctnResetPasswordControls')?.remove();
                    this.el.querySelector('.ctnPwdReqmts')?.remove();
                    this.el.querySelector('.oAuthControls')?.remove();
                }
            }
    
            if (this.validPassword) {
                this.el.querySelector('.btnChangePassword')?.classList.add('good');
            } else {
                this.el.querySelector('.btnChangePassword')?.classList.remove('good');
            }
    
            this.updateProceedToLoginButtonState();
        }
        
        validateEmailToken() {
            var that = this;
            DplLink.apiCall({
                type: 'POST',
                url: DplLink.resthost + DplLink.apiUrls.pwResetTokenValidation,
                data: { userid: this.userid, useridentityid: this.useridentityid, pwresettoken: this.pwresettoken },
                success: function(response) {
                    if (response.length === 0) {
                        that.errmsg = "Invalid email link. Try again or contact tech support.";
                        that.validToken = false;
                    } else {
                        if (response[0].expired) {
                            that.errmsg = "Email link has expired. Try again or contact support at support@dplwireless.com or call 1-800-561-8880";
                            that.validToken = false;
                        } else {
                            that.errmsg = "";
                            that.validToken = true;
                        }
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    that.validToken = false;
                    that.errmsg = jqXHR.responseText;
                },
                complete: function() {
                    that.render();
                    that.updateView();
                }
            });
        }

        assesPasswordStrength(e) {
            const sender = e.currentTarget;

            const szNewPassword = this.el.querySelector('.newPassword').value.trim();
            const szConfirmPassword = this.el.querySelector('.confirmPassword').value.trim();
    
            this.conditionRequired.pwLength = szNewPassword.length >= 8;
            this.conditionRequired.pwMatch = szNewPassword.length !== 0 && szNewPassword === szConfirmPassword;
    
            this.conditionStrength.pwUpper = /[A-Z]/.test(szNewPassword);
            this.conditionStrength.pwLower = /[a-z]/.test(szNewPassword);
            this.conditionStrength.pwDigit = /[0-9]/.test(szNewPassword);
            this.conditionStrength.pwSpChar = /[!@#$%^&*?_~\-£.,`<>\/\(\)=\+\:\;\{\}\[\]\\|]/.test(szNewPassword);
    
            const validRequired = Object.values(this.conditionRequired).every(v => v);
            const validStrength = Object.values(this.conditionStrength).filter(v => v).length >= 3;
    
            this.validNewPassword = validStrength && this.conditionRequired.pwLength;
            this.validPassword = validRequired && validStrength;
            this.updateStrength();
    
            if (sender.classList.contains('newPassword')) {
                this.el.querySelector('.ctnReqmtsNewPwd').style.display = 'block';
            } else if (sender.classList.contains('confirmPassword')) {
                this.el.querySelector('.ctnReqmtsConfirmPwd').style.display = 'block';
            }
    
            this.render();
        }
    
        onFocusoutPwdTextbox() {
            this.el.querySelectorAll('.ctnPwdReqmts').forEach(el => el.style.display = 'none');
        }
    
        onChangePasswordClick() {
            if (this.pwresettoken) {
                this.changePasswordNoAuth();
            } else {
                this.changePassword();
            }
        }
    
        changePasswordNoAuth() {
            if (this.validPassword) {
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                DplLink.apiCall({
                    type: 'POST',
                    url: DplLink.resthost + DplLink.apiUrls.resetPassword,
                    data: {  useridentityid: this.useridentityid, userid: this.userid, newpassword: szNewPassword, pwresettoken: this.pwresettoken },
                    success: (response) => {
                        this.msgstatus = '';
                        if (response.length === 0) {
                            this.errmsg = 'Invalid email link. Try again or contact tech support.';
                        } else if (response[0].expired) {
                            this.errmsg = "Email link has expired. Try again or contact support at support@dplwireless.com or call 1-800-561-8880";
                        } else if (response === "password changed") {
                            this.updatedPassword = true;
                            this.errmsg = 'Successfully updated Password.';
                            this.msgstatus = 'good';
                            this.updateProceedToLoginButtonState();
                        } else {
                            this.errmsg = 'Something went wrong when changing password. Try again or contact tech support.';
                        }
                        this.updateErrMsg();
                    },
                    error: (jqXHR) => {
                        this.errmsg = jqXHR.responseText;
                        this.msgstatus = '';
                        this.updateErrMsg();
                    }
                });
            }
        }
    
        changePassword() {
            if (this.validPassword) {
                const szOldPassword = this.el.querySelector('.oldPassword').value.trim();
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                DplLink.apiCall({
                    url: DplLink.resthost + DplLink.apiUrls.changePassword,
                    type: 'POST',
                    data: { useridentityid: this.useridentityid, userid: this.userid, newPassword: szNewPassword, oldPassword: szOldPassword },
                    success: (response) => {
                        this.msgstatus = response.status === 1 ? 'good' : '';
                        this.errmsg = response.desc;
                        this.updateErrMsg();
                    },
                    error: (jqXHR) => {
                        const res = JSON.parse(jqXHR.responseText);
                        this.errmsg = res.detail;
                        this.msgstatus = '';
                        this.updateErrMsg();
                    }
                });
            }
        }
    
        closeManageLoginView() {
            if (this.closeCallback) {
                this.closeCallback();
            }
        }
    
        updateStrength() {
            const passwordFields = this.el.querySelectorAll('.pwStrenghIndicator');
            passwordFields.forEach(field => field.classList.remove('good', 'warning'));
    
            if (this.bOldPasswordChecked) {
                const szOldPassword = this.el.querySelector('.oldPassword').value.trim();
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                if (szOldPassword !== szNewPassword) {
                    this.el.querySelector('.pwOldDiff .pwStrenghIndicator').classList.add('good');
                }
                if (szOldPassword.length >= 8) {
                    this.el.querySelector('.oldPassword').classList.add('good');
                }
            }
    
            Object.entries(this.conditionRequired).forEach(([key, value]) => {
                const indicator = this.el.querySelector(`.${key} .pwStrenghIndicator`);
                if (value) {
                    indicator.classList.add('good');
                    if (key === 'pwMatch') {
                        this.el.querySelector('.confirmPassword').classList.add('good');
                    }
                }
            });
    
            Object.entries(this.conditionStrength).forEach(([key, value]) => {
                const indicator = this.el.querySelector(`.${key} .pwStrenghIndicator`);
                if (this.validPassword) {
                    if (value) {
                        indicator.classList.add('good');
                    } else {
                        indicator.classList.add('warning');
                    }
                } else {
                    if (value) {
                        indicator.classList.add('good');
                    }
                }
            });
    
            if (this.validNewPassword) {
                this.el.querySelector('.newPassword').classList.add('good');
                this.el.querySelector('.validPasswordMsg').textContent = 'Perfect! Thank you for making your password more secure.';
                this.el.querySelector('.validPasswordMsg').style.display = 'block';
            } else {
                this.el.querySelector('.validPasswordMsg').textContent = '';
                this.el.querySelector('.validPasswordMsg').style.display = 'none';
            }
        }
    
        updateErrMsg() {
            const updateResult = this.el.querySelector('.updateResult');
            if (!updateResult || !this.errmsg) {
                return;
            }

            if (this.errmsg.length > 0) {
                updateResult.innerHTML = `<div class="resChangePwd ${this.msgstatus}"></div><div class="res">${this.errmsg}</div>`;
                updateResult.style.display = 'block';
            } else {
                updateResult.innerHTML = '';
                updateResult.style.display = 'none';
            }
        }
    
        updateProceedToLoginButtonState() {
            const loginUrl = this.el.querySelector('.loginUrl');
            if (this.pwresettoken && (this.oauthstatus.google.isLinked || this.oauthstatus.microsoft.isLinked || this.updatedPassword)) {
                loginUrl.style.display = 'block';
            } else {
                loginUrl.style.display = 'none';
            }
        }
    
        updateOauthLinkedStatus() {
            this.updateErrMsg();
            if (this.validToken) {
                syncOauthProviderUi(this.el, 'google', this.oauthstatus);
                syncOauthProviderUi(this.el, 'microsoft', this.oauthstatus);
            }
            this.updateProceedToLoginButtonState();
        }
    
        fetchOauthControls() {
            const gadminuserid = DplLink.getClonerUserId();
            const userId = DplLink.currentUser.userid;
    
            if (this.pwresettoken) {
                checkOAuthLink_unautherized(OAUTHTYPE_GOOGLE, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
                checkOAuthLink_unautherized(OAUTHTYPE_MICROSOFT, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
            } else if (DplLink.getUserId()) {
                if (this.userid === userId) {
                    checkOAuthLink(OAUTHTYPE_GOOGLE, this.afterSocialAction.bind(this));
                    checkOAuthLink(OAUTHTYPE_MICROSOFT, this.afterSocialAction.bind(this));
                } else {
                    checkOAuthLink_unautherized(OAUTHTYPE_GOOGLE, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
                    checkOAuthLink_unautherized(OAUTHTYPE_MICROSOFT, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
                }
            }
        }
    
        afterSocialAction(err, oauthType, bIsLinked, ImageURL, oauthUserName) {
            if (err && err.code && err.err_message) {
                this.errmsg = err.err_message;
                this.msgstatus = '';
            }
    
            if (oauthType === OAUTHTYPE_GOOGLE) {
                this.oauthstatus.google.isLinked = bIsLinked;
                this.oauthstatus.google.imageurl = ImageURL;
                this.oauthstatus.google.oauthUserName = oauthUserName;
            } else if (oauthType === OAUTHTYPE_MICROSOFT) {
                this.oauthstatus.microsoft.isLinked = bIsLinked;
                this.oauthstatus.microsoft.imageurl = ImageURL;
                this.oauthstatus.microsoft.oauthUserName = oauthUserName;
            }
    
            this.updateOauthLinkedStatus();
        }

        clickGoogleAuthorizeButton() {
            if (this.bCanLinkSocialAccount) {
                if (!this.pwresettoken) {
                    linkGoogleAccount(true, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
                } else {
                    linkGoogleAccount(true, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
                }
            } else {
                this.msgstatus = '';
                this.errmsg = 'Can\'t link social account for other users';
                this.updateOauthLinkedStatus();
            }
        }

        clickGoogleDeauthorizeButton() {
            this.errmsg = '';
            if (!this.pwresettoken) {
                linkGoogleAccount(false, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
            } else {
                linkGoogleAccount(false, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
            }
        }

        clickMicrosoftAuthorizeButton() {
            this.errmsg = '';
            if (this.bCanLinkSocialAccount) {
                if (!this.pwresettoken) {
                    linkMicrosoftAccount(true, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
                } else {
                    linkMicrosoftAccount(true, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
                }
            } else {
                this.msgstatus = '';
                this.errmsg = 'Can\'t link social account for other users';
                this.updateOauthLinkedStatus();
            }
        }

        clickMicrosoftDeauthorizeButton() {
            this.errmsg = '';
            if (!this.pwresettoken) {
                linkMicrosoftAccount(false, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
            } else {
                linkMicrosoftAccount(false, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
            }
        }
    }
    
    DplLink.ManageLoginView = ManageLoginView;


    class ManagePasswordView extends LitLite {

    
        constructor(options) {
            super();
            this.updatedPassword = false;
            this.useridentityid = options.useridentityid;
            this.userid = options.userid;
            this.username = options.username || '';
            this.pwresettoken = options.pwresettoken || '';
            this.closeCallback = options.closeCallback || null;

            this.validPassword = false;
            this.bOldPasswordChecked = true;
            this.bCanLinkSocialAccount = false;
            this.validNewPassword = false;
            this.conditionRequired = { pwLength: false, pwMatch: false };
            this.conditionStrength = { pwUpper: false, pwLower: false, pwDigit: false, pwSpChar: false };
            this.validToken = true;
            this.errmsg = '';
            this.msgstatus = '';

            this.initialize();
        }
    
        initialize() {
            if (this.pwresettoken) {
                this.bOldPasswordChecked = false;
                this.bCanLinkSocialAccount = true;
            } else {
                if ((this.useridentityid === DplLink.currentUser.useridentityid || this.userid === DplLink.currentUser.userid) && !DplLink.getClonerUserId()) {
                    this.bCanLinkSocialAccount = true;
                }
                if (DplLink.getClonerUserId()) { // this should really be done serverside instead
                    this.bOldPasswordChecked = false;
                }
            }
    
            this.render();
            if (this.pwresettoken) {
                this.validateEmailToken();
                this.el.querySelector('.newPassword').focus();
            } else {
                this.updateView();
            }
        }
    
        render() {
            this.el.innerHTML = `
                <div class="closePanel">
                    <div class="ic-cancel closeManageLoginView" title="Close"></div>
                </div>
                <div class="box-sub-hdr">
                    <div class="title txt">Change Password</div>
                </div>
                <div class="box-content">
                    <div class="ctnResetPasswordControls">
                        <div class="ctnOldPassword ctn">
                            <label>Old Password</label>
                            <input type="password" class="oldPassword" placeholder="old password" autocomplete = "new-password">
                        </div>
                        <div class="ctnNewPassword ctn">
                            <label>New Password</label>
                            <input type="password" class="newPassword" placeholder="new password" autocomplete = "new-password">
                            <div class="ctnPwdReqmts ctnReqmtsNewPwd" style="display: none;">
                                <div class="ctnInnerPwdReqmts">
                                    <div class="validPasswordMsg"></div>
                                    <div class="conditions">Required</div>
                                    <div class="pwLength"><div class="pwStrenghIndicator"></div>At least 8 characters in length</div>
                                    <div class="conditions">3 of the following 4 conditions must be met.</div>
                                    <div class="pwUpper"><div class="pwStrenghIndicator"></div>Contains at least one upper-case character</div>
                                    <div class="pwLower"><div class="pwStrenghIndicator"></div>Contains at least one lower-case character</div>
                                    <div class="pwDigit"><div class="pwStrenghIndicator"></div>Contains at least one numeric digit</div>
                                    <div class="pwSpChar"><div class="pwStrenghIndicator"></div>Contains at least one special character</div>
                                </div>
                            </div>
                        </div>
                        <div class="ctnConfirmPassword ctn">
                            <label>Confirm Password</label>
                            <input type="password" class="confirmPassword" placeholder="confirm password" autocomplete = "new-password">
                            <div class="ctnPwdReqmts ctnReqmtsConfirmPwd" style="display: none;">
                                <div class="ctnInnerPwdReqmts">
                                    <div class="pwMatch"><div class="pwStrenghIndicator"></div>Confirm password matches new password</div>
                                </div>
                            </div>
                        </div>
                        <div class="ctnButton ctn">
                            <div class="btnChangePassword">Change</div>
                        </div>
                    </div>
                    <div class="updateResult"></div>
                    <div class="loginUrl ctnButton"><a class="btnStandard">Continue to login page...</a></div>
                </div>
            `;
    
            this.el.querySelector('.closeManageLoginView').addEventListener('click', this.closeManageLoginView.bind(this));
            this.el.querySelector('.oldPassword').addEventListener('keyup', this.assesPasswordStrength.bind(this));
            this.el.querySelector('.newPassword').addEventListener('keyup', this.assesPasswordStrength.bind(this));
            this.el.querySelector('.confirmPassword').addEventListener('keyup', this.assesPasswordStrength.bind(this));
            this.el.querySelector('.newPassword').addEventListener('focusout', this.onFocusoutPwdTextbox.bind(this));
            this.el.querySelector('.confirmPassword').addEventListener('focusout', this.onFocusoutPwdTextbox.bind(this));
            this.el.querySelector('.btnChangePassword').addEventListener('click', this.onChangePasswordClick.bind(this));
    
            this.updateView();
        }
    
        assesPasswordStrength(e) {
            const sender = e.currentTarget;
            const szNewPassword = this.el.querySelector('.newPassword').value.trim();
            const szConfirmPassword = this.el.querySelector('.confirmPassword').value.trim();
    
            this.conditionRequired.pwLength = szNewPassword.length >= 8;
            this.conditionRequired.pwMatch = szNewPassword.length !== 0 && szNewPassword === szConfirmPassword;
    
            this.conditionStrength.pwUpper = /[A-Z]/.test(szNewPassword);
            this.conditionStrength.pwLower = /[a-z]/.test(szNewPassword);
            this.conditionStrength.pwDigit = /[0-9]/.test(szNewPassword);
            this.conditionStrength.pwSpChar = /[!@#$%^&*?_~\-£.,`<>\/\(\)=\+\:\;\{\}\[\]\\|]/.test(szNewPassword);
    
            const validRequired = Object.values(this.conditionRequired).every(v => v);
            const validStrength = Object.values(this.conditionStrength).filter(v => v).length >= 3;
    
            this.validNewPassword = validStrength && this.conditionRequired.pwLength;
            this.validPassword = validRequired && validStrength;
    
            this.updateStrength();
    
            if (sender.classList.contains('newPassword')) {
                this.el.querySelector('.ctnReqmtsNewPwd').style.display = 'block';
            } else if (sender.classList.contains('confirmPassword')) {
                this.el.querySelector('.ctnReqmtsConfirmPwd').style.display = 'block';
            }
    
            this.updateView();
        }
    
        onFocusoutPwdTextbox() {
            this.el.querySelectorAll('.ctnPwdReqmts').forEach(el => el.style.display = 'none');
        }
    
        onChangePasswordClick() {
            if (this.pwresettoken) {
                this.changePasswordNoAuth();
            } else {
                this.changePassword();
            }
        }
    
        changePasswordNoAuth() {
            if (this.validPassword) {
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                DplLink.apiCall({
                    type: 'POST',
                    url: DplLink.resthost + DplLink.apiUrls.resetPassword,
                    data: {  useridentityid: this.useridentityid, userid: this.userid, newpassword: szNewPassword, pwresettoken: this.pwresettoken },
                    success: (response) => {
                        this.msgstatus = '';
                        if (response.length === 0) {
                            this.errmsg = 'Invalid email link. Try again or contact tech support.';
                        } else if (response[0].expired) {
                            this.errmsg = "Email link has expired. Try again or contact support at support@dplwireless.com or call 1-800-561-8880";
                        } else if (response === "password changed") {
                            this.updatedPassword = true;
                            this.errmsg = 'Successfully updated Password.';
                            this.msgstatus = 'good';
                            this.updateProceedToLoginButtonState();
                        } else {
                            this.errmsg = 'Something went wrong when changing password. Try again or contact tech support.';
                        }
                        this.updateErrMsg();
                    },
                    error: (jqXHR) => {
                        this.errmsg = jqXHR.responseText;
                        this.msgstatus = '';
                        this.updateErrMsg();
                    }
                });
            }
        }
    
        changePassword() {
            if (this.validPassword) {
                const szOldPassword = this.el.querySelector('.oldPassword').value.trim();
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                DplLink.apiCall({
                    url: DplLink.resthost + DplLink.apiUrls.changePassword,
                    type: 'POST',
                    data: { useridentityid: this.useridentityid, userid: this.userid, newPassword: szNewPassword, oldPassword: szOldPassword },
                    success: (response) => {
                        this.msgstatus = response.status === 1 ? 'good' : '';
                        this.errmsg = response.desc;
                        this.updateErrMsg();
                    },
                    error: (jqXHR) => {
                        const res = JSON.parse(jqXHR.responseText);
                        this.errmsg = res.detail;
                        this.msgstatus = '';
                        this.updateErrMsg();
                    }
                });
            }
        }
    
        closeManageLoginView() {
            if (this.closeCallback) {
                this.closeCallback();
            }
        }
    
        updateStrength() {
            this.el.querySelectorAll('.pwStrenghIndicator').forEach(el => el.classList.remove('good', 'warning'));
            this.el.querySelectorAll('input').forEach(el => el.classList.remove('good', 'warning'));
        
            if (this.bOldPasswordChecked) {
                const szOldPassword = this.el.querySelector('.oldPassword').value.trim();
                const szNewPassword = this.el.querySelector('.newPassword').value.trim();
                const pwOldDiffIndicator = this.el.querySelector('.pwOldDiff .pwStrenghIndicator');
        
                if (pwOldDiffIndicator && szOldPassword !== szNewPassword) {
                    pwOldDiffIndicator.classList.add('good');
                }
        
                if (szOldPassword.length >= 8) {
                    this.el.querySelector('.oldPassword').classList.add('good');
                }
            }
        
            Object.entries(this.conditionRequired).forEach(([key, value]) => {
                const indicator = this.el.querySelector(`.${key} .pwStrenghIndicator`);
                if (indicator && value) {
                    indicator.classList.add('good');
                    if (key === 'pwMatch') {
                        this.el.querySelector('.confirmPassword').classList.add('good');
                    }
                }
            });
        
            Object.entries(this.conditionStrength).forEach(([key, value]) => {
                const indicator = this.el.querySelector(`.${key} .pwStrenghIndicator`);
                if (indicator) {
                    if (this.validPassword) {
                        if (value) {
                            indicator.classList.add('good');
                        } else {
                            indicator.classList.add('warning');
                        }
                    } else {
                        if (value) {
                            indicator.classList.add('good');
                        }
                    }
                }
            });
        
            const validPasswordMsg = this.el.querySelector('.validPasswordMsg');
            if (this.validNewPassword) {
                this.el.querySelector('.newPassword').classList.add('good');
                validPasswordMsg.textContent = 'Perfect! Thank you for making your password more secure.';
                validPasswordMsg.style.display = 'block';
            } else {
                validPasswordMsg.textContent = '';
                validPasswordMsg.style.display = 'none';
            }
        }
        
    
        updateErrMsg() {
            const updateResult = this.el.querySelector('.updateResult');
            if (this.errmsg.length > 0) {
                updateResult.innerHTML = `<div class="resChangePwd ${this.msgstatus}"></div><div class="res">${this.errmsg}</div>`;
                updateResult.style.display = 'block';
            } else {
                updateResult.innerHTML = '';
                updateResult.style.display = 'none';
            }
        }
    
        updateProceedToLoginButtonState() {
            const loginUrl = this.el.querySelector('.loginUrl');
            if (this.pwresettoken && this.updatedPassword) {
                loginUrl.style.display = 'block';
            } else {
                loginUrl.style.display = 'none';
            }
        }
    
        updateView() {
            this.updateErrMsg();
            if (this.pwresettoken) {
                this.el.querySelector('.ctnOldPassword') ? this.el.querySelector('.ctnOldPassword').style.display = 'none' : null;
                this.el.querySelector('.title').textContent = `Change password for ${this.username}`;
    
                if (!this.validToken) {
                    this.el.querySelector('.ctnResetPasswordControls')?.remove();
                    this.el.querySelector('.ctnPwdReqmts')?.remove();
                }
            }
    
            if (this.validPassword) {
                this.el.querySelector('.btnChangePassword')?.classList.add('good');
            } else {
                this.el.querySelector('.btnChangePassword')?.classList.remove('good');
            }
    
            this.updateProceedToLoginButtonState();
        }
    
        validateEmailToken() {
            DplLink.apiCall({
                type: 'POST',
                url: DplLink.resthost + DplLink.apiUrls.pwResetTokenValidation,
                data: { p1: this.userid, p2: this.pwresettoken },
                success: (response) => {
                    if (response.length === 0) {
                        this.errmsg = "Invalid email link. Try again or contact tech support.";
                        this.validToken = false;
                    } else if (response[0].expired) {
                        this.errmsg = "Email link has expired. Try again or contact support at support@dplwireless.com or call 1-800-561-8880";
                        this.validToken = false;
                    } else {
                        this.errmsg = "";
                        this.validToken = true;
                    }
                },
                error: (jqXHR) => {
                    this.validToken = false;
                    this.errmsg = jqXHR.responseText;
                },
                complete: () => {
                    this.updateView();
                }
            });
        }
    }

   DplLink.ManagePasswordView = ManagePasswordView;

   class ManageOauthView extends LitLite {
        constructor(options) {
            super();
            this.userid = options.userid || '';
            this.useridentityid = options.useridentityid || '';
            this.username = options.username || '';
            this.bCanLinkSocialAccount = this.userid == DplLink.currentUser.userid && !DplLink.getClonerUserId();
            this.validToken = true;
            this.errmsg = '';
            this.msgstatus = '';
            this.oauthstatus = { google: {}, microsoft: {} };

            this.initialize();
        }

        initialize() {
            this.render();
            this.update();
            this.fetchOauthControls();
        }

        render() {
            this.el.innerHTML = `
                <div class="oauthlogin">
                    <div class="updateResult" style="display: none;"></div>
                    <div class="oAuthControls"></div>
                </div>
            `;

            const oauthControlsEl = this.el.querySelector('.oAuthControls');
            LH.render(oauthProviderBlocksLit(this), oauthControlsEl, { host: this });
        }

        update() {
            this.updateOauthLinkedStatus();
        }

        fetchOauthControls() {
            const gadminuserid = DplLink.getClonerUserId();
            const userId = DplLink.currentUser.userid;

            if (DplLink.getUserId()) {
                if (this.userid === userId) {
                    checkOAuthLink(OAUTHTYPE_GOOGLE, this.afterSocialAction.bind(this));
                    checkOAuthLink(OAUTHTYPE_MICROSOFT, this.afterSocialAction.bind(this));
                } else {
                    checkOAuthLink_unautherized(OAUTHTYPE_GOOGLE, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
                    checkOAuthLink_unautherized(OAUTHTYPE_MICROSOFT, this.useridentityid, this.userid, this.afterSocialAction.bind(this));
                }
            }
        }

        updateErrMsg() {
            const updateResult = this.el.querySelector('.updateResult');
            if (this.errmsg.length > 0) {
                updateResult.innerHTML = `<div class="resChangePwd ${this.msgstatus}"></div><div class="res">${this.errmsg}</div>`;
                updateResult.style.display = 'block';
            } else {
                updateResult.innerHTML = '';
                updateResult.style.display = 'none';
            }
        }

        updateOauthLinkedStatus() {
            this.updateErrMsg();
            syncOauthProviderUi(this.el, 'google', this.oauthstatus);
            syncOauthProviderUi(this.el, 'microsoft', this.oauthstatus);
        }

        clickGoogleAuthorizeButton() {
            if (this.bCanLinkSocialAccount) {
                if (!this.pwresettoken) {
                    linkGoogleAccount(true, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
                } else {
                    linkGoogleAccount(true, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
                }
            } else {
                this.msgstatus = '';
                this.errmsg = 'Can\'t link social account for other users';
                this.updateOauthLinkedStatus();
            }
        }

        clickGoogleDeauthorizeButton() {
            this.errmsg = '';
            if (!this.pwresettoken) {
                linkGoogleAccount(false, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
            } else {
                linkGoogleAccount(false, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
            }
        }

        clickMicrosoftAuthorizeButton() {
            if (this.bCanLinkSocialAccount) {
                if (!this.pwresettoken) {
                    linkMicrosoftAccount(true, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
                } else {
                    linkMicrosoftAccount(true, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
                }
            } else {
                this.msgstatus = '';
                this.errmsg = 'Can\'t link social account for other users';
                this.updateOauthLinkedStatus();
            }
        }

        clickMicrosoftDeauthorizeButton() {
            this.errmsg = '';
            linkMicrosoftAccount(false, 0, this.userid, '', this.afterSocialAction.bind(this));
            if (!this.pwresettoken) {
                linkMicrosoftAccount(false, 0, this.useridentityid, this.userid, '', this.afterSocialAction.bind(this));
            } else {
                linkMicrosoftAccount(false, 1, this.useridentityid, this.userid, this.pwresettoken, this.afterSocialAction.bind(this));
            }
        }

        afterSocialAction(err, oauthType, bIsLinked, ImageURL, oauthUserName) {
            if (err && err.code && err.err_message) {
                this.errmsg = err.err_message;
                this.msgstatus = '';
            }

            if (oauthType === OAUTHTYPE_GOOGLE) {
                this.oauthstatus.google.isLinked = bIsLinked;
                this.oauthstatus.google.imageurl = ImageURL;
                this.oauthstatus.google.oauthUserName = oauthUserName;
            } else if (oauthType === OAUTHTYPE_MICROSOFT) {
                this.oauthstatus.microsoft.isLinked = bIsLinked;
                this.oauthstatus.microsoft.imageurl = ImageURL;
                this.oauthstatus.microsoft.oauthUserName = oauthUserName;
            }

            this.updateOauthLinkedStatus();
        }
    }

    DplLink.ManageOauthView = ManageOauthView;



    class ProvideEmailView extends LitLite {
        constructor(options) {
            super();
            this.ctnPopup = options.ctnPopup || null;
            this.conditionRequired = { validEmail: false, emailMatch: false };
            this.result = { resultcode: null, message: '' };
    
            this.initialize();
        }
    
        initialize() {
            this.render();
            this.updateEmailValue();
            this.update();
        }
    
        render() {
            this.el.innerHTML = `
                <div class="closePanel">
                    <div class="ic-cancel closeProvideEmailView" title="Close"></div>
                </div>
                <div class="box-sub-hdr">
                    <div class="title txt">Please provide your email address.</div>
                </div>
                <div class="box-content">
                    <div class="message">
                        <div>Please provide an email address we can link to your account so that we can provide you with better login security and service.</div>
                    </div>
                    <div class="ctnSetEmailControls">
                        <div class="ctnEmailAddress ctn">
                            <label>Email Address</label>
                            <input type="email" class="newEmail" placeholder="Email Address">
                        </div>
                        <div class="ctnConfirmEmailAddress ctn">
                            <label>Confirm Email</label>
                            <input type="email" class="confirmEmail" placeholder="Confirm Email Address">
                        </div>
                        <div class="ctnButton ctn">
                            <div class="btnUpdate btnStandard">Update</div>
                            <div class="btnCancel btnStandard">Not now</div>
                        </div>
                    </div>
                    <div class="ctnEmailReqmts">
                        <div class="conditions">Required</div>
                        <div class="validEmail pwStrenghIndicator"></div>
                        <div class="emailMatch pwStrenghIndicator"></div>
                    </div>
                    <div class="updateResult"></div>
                </div>
            `;
    
            this.el.querySelector('.closeProvideEmailView').addEventListener('click', this.closeProvideEmailView.bind(this));
            this.el.querySelector('.newEmail').addEventListener('keyup', this.assessEmail.bind(this));
            this.el.querySelector('.confirmEmail').addEventListener('keyup', this.assessEmail.bind(this));
            this.el.querySelector('.btnUpdate').addEventListener('click', this.provideEmail.bind(this));
            this.el.querySelector('.btnCancel').addEventListener('click', this.onClickNotNow.bind(this));
        }
    
        update() {
            this.updateEmailReqmts();
        }
    
        updateEmailValue() {
            if (DplLink.currentUser && DplLink.currentUser.email) {
                this.el.querySelector('.newEmail').value = DplLink.currentUser.email;
                this.el.querySelector('.confirmEmail').value = DplLink.currentUser.email;
                this.assessEmail();
            }
        }
    
        assessEmail() {
            const newEmail = this.el.querySelector('.newEmail').value.trim();
            const confirmEmail = this.el.querySelector('.confirmEmail').value.trim();
            const regexEmail = /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6}$/;
    
            this.conditionRequired.validEmail = regexEmail.test(newEmail);
            this.conditionRequired.emailMatch = newEmail.length > 0 && newEmail === confirmEmail;
    
            this.update();
        }
    
        provideEmail() {
            if (this.conditionRequired.emailMatch && this.conditionRequired.validEmail) {
                const newEmail = this.el.querySelector('.newEmail').value.trim();
                DplLink.apiCall({
                    type: 'POST',
                    url: DplLink.resthost + DplLink.apiUrls.changeuseremail,
                    data: { p1: newEmail },
                    success: (response) => {
                        const result = response[0].resultcode;
                        if (result === -1) {
                            this.result = { resultcode: 1, message: `The email address, ${newEmail} is already confirmed.` };
                        } else {
                            DplLink.requestEmailValidation(DplLink.currentUser.userid, 0, () => {
                                this.result = {
                                    resultcode: 1,
                                    message: `Thank you for registering your email address.<br>We've sent a confirmation email to ${newEmail}. Once you get the confirmation email, please follow the link to complete the email verification process.`
                                };
                            });
                        }
                        this.updateResult();
                    }
                });
            }
        }
    
        updateResult() {
            const updateResult = this.el.querySelector('.updateResult');
            const title = this.el.querySelector('.title');
            const message = this.el.querySelector('.message');
            const setEmailControls = this.el.querySelector('.ctnSetEmailControls');
            const emailReqmts = this.el.querySelector('.ctnEmailReqmts');
    
            switch (this.result.resultcode) {
                case -1:
                    updateResult.innerHTML = `<div class="resSetEmail"></div><div class="res">${this.result.message}</div>`;
                    updateResult.style.display = 'block';
                    break;
                case 1:
                    message.style.display = 'none';
                    setEmailControls.style.display = 'none';
                    emailReqmts.style.display = 'none';
                    title.textContent = 'Thank you for registering email address.';
                    updateResult.innerHTML = `<div class="res">${this.result.message}</div>`;
                    updateResult.style.display = 'block';
                    break;
                default:
                    updateResult.style.display = 'none';
                    break;
            }
        }
    
        updateEmailReqmts() {
            const validEmail = this.el.querySelector('.validEmail');
            const emailMatch = this.el.querySelector('.emailMatch');
    
            if (this.conditionRequired.validEmail) {
                validEmail.classList.add('good');
                validEmail.textContent = 'Email address is valid.';
            } else {
                validEmail.classList.remove('good');
                validEmail.textContent = 'Email address is invalid.';
            }
    
            if (this.conditionRequired.emailMatch) {
                emailMatch.classList.add('good');
                emailMatch.textContent = 'Confirm email address matches.';
            } else {
                emailMatch.classList.remove('good');
                emailMatch.textContent = 'Confirm email address is different.';
            }
        }
    
        onClickNotNow() {
            const curTS = Math.round(new Date().getTime() / 1000);
            DplLink.safeSetItem('DplLink.lastemailpopuptime', curTS);
            this.closeProvideEmailView();
        }
    
        closeProvideEmailView() {
            if (this.ctnPopup) {
                this.ctnPopup.hide();
            }
        }
    }
    
    DplLink.ProvideEmailView = ProvideEmailView;


    class EmailValidationView extends LitLite {
        constructor(options) {
            super();
            this.el.className = "emailValidationView";
            this.userid = options.userid || '';
            this.token = options.token || '';
            this.create = options.create || false;
            this.username = options.username || '';
            this.result = { resultcode: null, message: '' };
            this.closeCallback = options.closeCallback || null;
    
            this.initialize();
        }
    
        initialize() {
            this.render();
            this.validateEmail();
        }
    
        render() {
            this.el.innerHTML = `
                <div class="closePanel">
                    <div class="ic-cancel closeEmailValidationView" title="Close"></div>
                </div>
                <div class="box-sub-hdr">
                    <div class="title txt">Email Confirmation</div>
                </div>
                <div class="box-content">
                    <div class="updateResult">Your email address is being validated...</div>
                    <div class="ctnButton"><a class="btnStandard">Change Password</a></div>
                </div>
            `;
    
            this.el.querySelector('.closeEmailValidationView').addEventListener('click', this.closeEmailValidationView.bind(this));
            this.el.querySelector('.ctnButton').addEventListener('click', this.openManageLogin.bind(this));
    
            this.el.querySelector('.ctnButton').style.display = 'none';
        }
    
        validateEmail() {
            DplLink.apiCall({
                type: 'POST',
                url: DplLink.resthost + DplLink.apiUrls.emailValidation,
                data: { p1: this.userid, p2: this.token },
                success: (response) => {
                    if (response.length === 0) {
                        this.result = { icon: 'invalid', message: 'Invalid token supplied. Try again or contact tech support.' };
                    } else {
                        if (response[0].isemailvalidated === 1) {
                            this.result = { icon: 'valid', message: `The email address for ${this.username} was already confirmed.` };
                        } else if (response[0].pwresettoken) {
                            this.pwresettoken = response[0].pwresettoken;
                            this.result = {
                                icon: 'valid',
                                message: `Thank you. Your email address is confirmed<br>(username: ${this.username}).`
                            };
                            if (parseInt(this.create) === 1) {
                                this.el.querySelector('.closePanel').style.display = 'none';
                                this.el.querySelector('.btnStandard').textContent = 'Set Password';
                            } else {
                                this.result.message += '<br>Click on Change Password if you would like to change password or login method.';
                            }
                            this.el.querySelector('.ctnButton').style.display = 'block';
                        } else {
                            this.result = { icon: 'invalid', message: response[0].expired ? 'Email link has expired. Try again or contact support at support@dplwireless.com or call 1-800-561-8880' : 'Error running a query: password reset token.' };
                        }
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.log(`Error: ${textStatus}, ${errorThrown}, Status: ${jqXHR.status}, Response: ${jqXHR.responseText}`);
                },
                complete: () => {
                    this.update();
                }
            });
        }
    
        update() {
            const updateResult = this.el.querySelector('.updateResult');
            if (this.result.icon === 'invalid') {
                updateResult.innerHTML = `<div class="resValidateEmail"></div>${this.result.message}`;
            } else if (this.result.icon === 'valid') {
                updateResult.innerHTML = `<div class="res">${this.result.message}</div>`;
            } else {
                updateResult.innerHTML = '';
            }
        }
    
        openManageLogin() {
            const popup = new DplLink.PopupLit();
            popup.show(
                new DplLink.ManageLoginView({
                    useridentityid: this.useridentityid,
                    userid: this.userid,
                    pwresettoken: this.pwresettoken,
                    create: 1,
                    username: this.username,
                    closeCallback: () => { popup.hide(); }
                }).el,
                { my: 'center top', at: 'center top+6%', of: window, collision: 'fit' },
                'never'
            );
            this.closeEmailValidationView();
        }
    
        closeEmailValidationView() {
            if (this.closeCallback) {
                this.closeCallback();
            }
        }
    }
    
    DplLink.EmailValidationView = EmailValidationView;

    class TermsOfServiceView extends LitLite {
        constructor(options) {
            super();
            this.ctnPopup = options.ctnPopup || null;
            this.finishedCallBack = options.onCloseCallBack || null;
    
            this.initialize();
        }
    
        initialize() {
            this.render();
            this.update();
        }
    
        render() {
            const template = LH.html`
                <div class="title">DPL Terms of Service</div>
                <div class="terms"></div>
                <div class="controls">
                    "I have read and agree to the Terms of Service." 
                    <div class="tosaccept">I Accept</div>
                </div>
            `;
    
            LH.render(template, this.el);
            this.el.style.maxHeight = `${window.innerHeight * 0.9}px`;
    
            this.el.querySelector('.tosaccept').addEventListener('click', this.acceptTermsOfService.bind(this));
        }
    
        update() {
            fetch(DplLink.marketingHost + "/tos.html")
                .then(response => response.text())
                .then(data => {
                    this.el.querySelector('.terms').innerHTML = data;
                })
                .catch(error => console.error("Error fetching terms of service:", error));
        }
    
        acceptTermsOfService() {
            DplLink.apiCall({
                type: 'GET',
                url: DplLink.resthost + DplLink.apiUrls.acceptTermsOfService,
                data: {
                    tosver: tosVersion
                },
                error: () => {
                    this.closeTermsOfServiceView();
                },
                success: () => {
                    document.getElementById('overlay').remove();
                    this.closeTermsOfServiceView();
                }
            });
        }
    
        closeTermsOfServiceView() {
            if (this.ctnPopup) {
                this.ctnPopup.hide();
            }
            if (this.finishedCallBack) {
                this.finishedCallBack();
            }
        }
    }

    DplLink.TermsOfServiceView = TermsOfServiceView;
    


}).call(this);